import { render, staticRenderFns } from "./individualAccountFormPlatform.vue?vue&type=template&id=556c6692&"
import script from "./individualAccountFormPlatform.vue?vue&type=script&lang=js&"
export * from "./individualAccountFormPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports